
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CompanyLogoEntriesPage,
  CompanyLogoEntry,
  UpsertCompanyLogoEntryRequest,
} from '../models';
import {
    CompanyLogoEntriesPageFromJSON,
    CompanyLogoEntriesPageToJSON,
    CompanyLogoEntryFromJSON,
    CompanyLogoEntryToJSON,
    UpsertCompanyLogoEntryRequestFromJSON,
    UpsertCompanyLogoEntryRequestToJSON,
} from '../models';

export interface DeleteCompanyLogoEntryRequest {
    normalizedCompanyName: string;
}

export interface SearchCompanyLogoEntriesRequest {
    search?: string;
    page?: number;
    size?: number;
    hasLogoUrl?: boolean;
}

export interface UpdateCompanyLogoEntryRequest {
    normalizedCompanyName: string;
    upsertCompanyLogoEntryRequest: UpsertCompanyLogoEntryRequest;
}

export interface UpsertCompanyLogoEntryOperationRequest {
    upsertCompanyLogoEntryRequest: UpsertCompanyLogoEntryRequest;
}

/**
 * 
 */
export class CompanyLogoAdminApi extends runtime.BaseAPI {

    /**
     * Delete the logo recorded for a company
          */
    async deleteCompanyLogoEntryRaw(requestParameters: DeleteCompanyLogoEntryRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['normalizedCompanyName'] == null) {
            throw new runtime.RequiredError(
                'normalizedCompanyName',
                'Required parameter "normalizedCompanyName" was null or undefined when calling deleteCompanyLogoEntry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/profile/api/admin/company-logo/entries/{normalizedCompanyName}`.replace(`{${"normalizedCompanyName"}}`, encodeURIComponent(String(requestParameters['normalizedCompanyName']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Delete the logo recorded for a company
          */
    async deleteCompanyLogoEntry(requestParameters: DeleteCompanyLogoEntryRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCompanyLogoEntryRaw(requestParameters, initOverrides);
    }

    /**
     * Search the recorded company logos, ignoring case and accents
          */
    async searchCompanyLogoEntriesRaw(requestParameters: SearchCompanyLogoEntriesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CompanyLogoEntriesPage>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['hasLogoUrl'] != null) {
            queryParameters['hasLogoUrl'] = requestParameters['hasLogoUrl'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<CompanyLogoEntriesPage>({
            path: `/profile/api/admin/company-logo/entries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=CompanyLogoEntriesPageFromJSON(response._data); }
        return response;
    }

    /**
     * Search the recorded company logos, ignoring case and accents
          */
    async searchCompanyLogoEntries(requestParameters: SearchCompanyLogoEntriesRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CompanyLogoEntriesPage> {
        const response = await this.searchCompanyLogoEntriesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Edit the displayed name and logo url of a recorded company, renaming its key when the normalized name changes
          */
    async updateCompanyLogoEntryRaw(requestParameters: UpdateCompanyLogoEntryRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CompanyLogoEntry>> {
        if (requestParameters['normalizedCompanyName'] == null) {
            throw new runtime.RequiredError(
                'normalizedCompanyName',
                'Required parameter "normalizedCompanyName" was null or undefined when calling updateCompanyLogoEntry().'
            );
        }

        if (requestParameters['upsertCompanyLogoEntryRequest'] == null) {
            throw new runtime.RequiredError(
                'upsertCompanyLogoEntryRequest',
                'Required parameter "upsertCompanyLogoEntryRequest" was null or undefined when calling updateCompanyLogoEntry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<CompanyLogoEntry>({
            path: `/profile/api/admin/company-logo/entries/{normalizedCompanyName}`.replace(`{${"normalizedCompanyName"}}`, encodeURIComponent(String(requestParameters['normalizedCompanyName']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertCompanyLogoEntryRequestToJSON(requestParameters['upsertCompanyLogoEntryRequest']),
        }, initOverrides);

        if (response._data) { response._data=CompanyLogoEntryFromJSON(response._data); }
        return response;
    }

    /**
     * Edit the displayed name and logo url of a recorded company, renaming its key when the normalized name changes
          */
    async updateCompanyLogoEntry(requestParameters: UpdateCompanyLogoEntryRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CompanyLogoEntry> {
        const response = await this.updateCompanyLogoEntryRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Create or replace the logo recorded for a company
          */
    async upsertCompanyLogoEntryRaw(requestParameters: UpsertCompanyLogoEntryOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CompanyLogoEntry>> {
        if (requestParameters['upsertCompanyLogoEntryRequest'] == null) {
            throw new runtime.RequiredError(
                'upsertCompanyLogoEntryRequest',
                'Required parameter "upsertCompanyLogoEntryRequest" was null or undefined when calling upsertCompanyLogoEntry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<CompanyLogoEntry>({
            path: `/profile/api/admin/company-logo/entries`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertCompanyLogoEntryRequestToJSON(requestParameters['upsertCompanyLogoEntryRequest']),
        }, initOverrides);

        if (response._data) { response._data=CompanyLogoEntryFromJSON(response._data); }
        return response;
    }

    /**
     * Create or replace the logo recorded for a company
          */
    async upsertCompanyLogoEntry(requestParameters: UpsertCompanyLogoEntryOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CompanyLogoEntry> {
        const response = await this.upsertCompanyLogoEntryRaw(requestParameters, initOverrides);
        return response._data;
    }

}
